import styled from 'styled-components'
import PhoneInput from 'react-phone-number-input'

const DARK = '#284047'
const ACCENT_RING = 'rgba(253, 189, 87, 0.45)'
const BORDER = '#c5cfd3'
const MUTED = '#55656b'
const CHEVRON = "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='8' viewBox='0 0 12 8'%3E%3Cpath d='M1 1l5 5 5-5' fill='none' stroke='%23284047' stroke-width='2'/%3E%3C/svg%3E\")"

const fieldBase = props => `
    background-color: ${props.error ? '#fdf0f1' : 'white'};
    border: 1px solid ${props.error ? '#d00000' : BORDER};
    border-radius: 8px;
    box-sizing: border-box;
    color: ${DARK};
    font-size: 16px;
    font-weight: 400;
    height: 46px;
    width: 100%;
`

const fieldFocus = props => `
    border-color: ${props.error ? '#d00000' : '#fdbd57'};
    box-shadow: 0 0 0 3px ${props.error ? 'rgba(208, 0, 0, 0.15)' : ACCENT_RING};
    outline: none;
`

// ------------------  HOME  -----------------------------
export const DivLogin = styled.div`
    align-items: center;
    background-color: #284047;
    display: block;
    position: absolute;
    width: 100%;
    height: auto;
    min-height: 100%;
`
export const DivHome = styled(DivLogin)`
    height: auto;
    min-height: 100%;
`
export const Img = styled.img`
    display: flex;
    margin: 46px auto 120px auto;
`
export const LogoLargeContainer = styled.div`
    width: 100%;
    max-width: 250px;
    height: 56px;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 auto 20px auto;
`

export const BrowserWarning = styled.div`
    width: 300px;
    padding: 20px;
    border-radius: 5px;
    background-color: white;
    text-align: center;
    display: flex;
    justify-content: center;
    margin: 40px auto 40px auto;
    color: #D00000;
`

// ------------------  LOGIN  --------------------------------
export const LabelLogin = styled.div`
    color: ${DARK};
    font-size: 14px;
    font-weight: 600;
    margin: 0 0 16px 0;
    position: relative;
    width: 100%;
`
export const StyledInputLight = styled.input`
    ${fieldBase}
    display: block;
    margin: 6px 0 0 0;
    padding: 0 12px;

    &:focus {
        ${fieldFocus}
    }
`
export const StyledInput = styled.input`
    ${fieldBase}
    display: block;
    margin: 6px 0 0 0;
    padding: 0 12px;

    &:focus {
        ${fieldFocus}
    }
`
export const Button2 = styled.button`
    align-items: center;
    background-color: ${DARK};
    border: none;
    border-radius: 8px;
    color: white;
    cursor: pointer;
    display: flex;
    font-size: 16px;
    font-weight: 700;
    height: 48px;
    justify-content: center;
    letter-spacing: 0.5px;
    margin: 24px 0 0 0;
    text-decoration: none;
    width: 100%;

    &:hover {
        background-color: #1d2f35;
    }

    &:focus-visible {
        box-shadow: 0 0 0 3px rgba(253, 189, 87, 0.7);
        outline: none;
    }

    &:active {
        transform: scale(0.98);
    }
`
export const Forgot = styled.button`
    font-size: 14px;
    color: white;
    display: flex;
    justify-content: center;
    margin: 30px auto 20px auto;
    width: 160px;
    font-weight: 700;
    border: none;
    border-bottom: 1px solid white;
    background: none;
`

export const TermsLink = styled.div`
    width: 250px;
    text-align: center;
    display: flex;
    justify-content: center;
    margin: 20px auto 20px auto;
    color: white;
`

// ------------------  ACCOUNT  --------------------------------
export const DivAccount = styled.div`
    background-color: #eef1f2;
    box-sizing: border-box;
    color: ${DARK};
    display: block;
    min-height: 100%;
    overflow-x: hidden;
    padding-bottom: 24px;
    position: absolute;
    width: 100%;
`
export const AuthCard = styled.div`
    background-color: white;
    border-radius: 12px;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
    box-sizing: border-box;
    margin: 24px auto 0 auto;
    max-width: 440px;
    padding: 28px 32px;
    width: calc(100% - 32px);

    @media (max-width: 400px) {
        padding: 24px 20px;
    }
`
export const PhoneInputStyled = styled(PhoneInput)`
    ${fieldBase}
    align-items: center;
    display: flex;
    margin: 6px 0 0 0;
    padding: 0 12px;

    &:focus-within {
        ${fieldFocus}
    }

    & .PhoneInputInput {
        background: transparent;
        border: none;
        color: ${DARK};
        font-size: 16px;
        height: 100%;
        min-width: 0;
        outline: none;
        padding: 0;
    }
`
export const Title = styled.div`
    display: flex;
    font-size: 22px;
    font-weight: 700;
    justify-content: center;
    margin: 0 0 8px 0;
    text-align: center;
`
export const MessageError = styled.div`
    background-color: #fdf0f1;
    border-left: 4px solid #d00000;
    border-radius: 8px;
    color: #7a0000;
    display: block;
    margin: 0 0 16px 0;
    padding: 12px 14px;
    width: 100%;
    box-sizing: border-box;

    & > div {
        font-size: 14px;
        font-weight: 400;
        justify-content: flex-start;
        margin: 0;
        text-align: left;
        width: 100%;
    }

    & > div:first-child {
        font-size: 13px;
        font-weight: 700;
        margin-bottom: 4px;
    }
`
export const TitleError = styled.div`
    align-items: center;
    display: flex;
    font-size: 13px;
    font-weight: 700;
    justify-content: flex-start;
    margin: 0 0 4px 0;
    width: 100%;
`
export const Message = styled.div`
    display: flex;
    font-size: 14px;
    font-weight: 400;
    justify-content: center;
    line-height: 1.5;
    margin: 0 0 16px 0;
    text-align: center;
    width: 100%;
`
export const Label = styled(LabelLogin)`
    color: ${DARK};
    position: relative;
`
export const Foot = styled.div`
    color: ${MUTED};
    display: flex;
    font-size: 12px;
    font-weight: 400;
    margin: -10px 0 16px 0;
    width: 100%;
`

export const ButtonWhite = styled(Button2)``
// ------------------  INFORMATION  --------------------------------
export const Subtitle = styled.div`
    color: ${MUTED};
    display: flex;
    font-size: 14px;
    font-weight: 400;
    justify-content: center;
    line-height: 1.5;
    margin: 0 0 20px 0;
    text-align: center;
    width: 100%;
`
export const Asterisk = styled.span`
    color: #d00000;
    font-size: 14px;
    display: contents;
`
export const IsReq = styled.p`
    color: #d00000;
    margin: 0;
    display: inline-block;
    position: absolute;
    right: 0px;
    top: 0;
    font-size: 14px;
`
export const ContainerOptions = styled.select`
    -webkit-appearance: none;
    appearance: none;
    ${fieldBase}
    background-image: ${CHEVRON};
    background-position: right 14px center;
    background-repeat: no-repeat;
    display: block;
    padding: 0 36px 0 12px;

    &:focus {
        ${fieldFocus}
    }

    &:disabled {
        background-color: #f3f5f6;
        color: ${MUTED};
    }
`

export const LabelEnd = styled(Label)`
    font-size: 14px;
    margin: 0 0 16px 0;
    text-align: center;

    & iframe {
        display: block;
        margin: 12px auto 0 auto;
        max-width: 100%;
    }
`
// ------------------  EMAIL ERROR  --------------------------------

export const MessageError1 = styled(MessageError)`
    opacity: 1;
    width: 100%;
`
export const StyledInputError = styled(StyledInput)`
    background-color: #fdf0f1;
    border-color: #d00000;
`
export const ButtonWhiteError = styled(ButtonWhite)`
    margin: 24px 0 0 0;
`
export const ButtonWhiteError1 = styled(ButtonWhite)`
    margin: 24px 0 0 0;
`
export const MessageReset = styled(Message)`
    margin: 0 0 16px 0;
`
export const MessageSendLink = styled(Message)`
    background-color: #e3f6ea;
    border-radius: 8px;
    color: #1c5b34;
    margin: 0 0 16px 0;
    padding: 14px 16px;
    box-sizing: border-box;
`
export const TitleSuccess = styled(Title)`
    margin: 0 auto 200px auto;
`
export const DropdownContainer = styled.div`
    cursor: pointer;
    margin: -10px 0 16px 0;
    position: relative;
    width: 100%;
`
